export default "__VITE_ASSET__UQ_HJxIs2wfYkqLzpj_TyA__"